import { CurriculumBreadcrumbDetails } from "../../../../config/BreadcrumbConfig";
import { Document, Page, pdfjs } from 'react-pdf';

import { useNavigate, useParams } from "react-router-dom";

import { CurriculumFiles } from "../../../../config/Constant";
import { useEffect, useState } from "react";
import ToolBar from "../../../../components/ToolBar";
import { Flex, Space } from "antd";
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import CreateButton from "../../../../components/ToolBar/Buttons/CreateButton";
import { toUpperCaseWithUnderscore } from "../../../../utils/commonFunctions";

pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`

const moduleInfo = {
    title: "Curriculum",
    permissionKeyPrefix: toUpperCaseWithUnderscore("Curriculum"),
};

const DetailsComponent: React.FC = () => {
    const { id }: any = useParams();
    const navigate = useNavigate();


    const PDFComponent = ({ url }: any) => {
        const [numPages, setNumPages] = useState(0);

        function onDocumentLoadSuccess({ numPages }: any) {
            setNumPages(numPages);
        }
        var element = [];
        for (let index = 0; index < numPages; index++) {
            element.push(index);

        }

        return <>
            <Flex justify={'center'} style={{ height: '77vh', overflow: 'auto' }}>
                {
                    url &&
                    <Document
                        file={url}
                        // file={'https://wordpress-1437041-5667602.cloudwaysapps.com/wp-content/uploads/2025/02/NECAEducationCareers_HostEmployerBrochure_Trainee_Web_2019.pdf'}
                        onLoadSuccess={onDocumentLoadSuccess}
                        onLoadError={console.error}
                        loading={'Loading...'}
                    >
                        {element.length > 0 && element.map((_, index) => <Page width={window.innerWidth * 0.8} key={index} pageNumber={index + 1} />)}
                    </Document>
                }
            </Flex>
        </>
    }

    const [selectedFile, setSelectedFile] = useState<any>(null);


    useEffect(() => {
        const selectedfilefound = CurriculumFiles.find((item: any) => item.id === id)
        if (selectedfilefound === undefined) {
            navigate("/curriculum");
        }
        else {
            setSelectedFile(selectedfilefound);
        }
    }, [id]);


    const downloadReport = () => {
        if (selectedFile != null) {

            const cuurl = new URL(location.origin + selectedFile.downloadFile)
            console.log(cuurl);
            const link = document.createElement("a");
            link.href = selectedFile.downloadFile;
            link.download = selectedFile.downloadFileName; // Set the file name for download
            link.target = "_blank"; // This is ignored when 'download' is set
            document.body.appendChild(link);
            link.click();
        }
    }


    return <>
        <ToolBar breadcrumbs={CurriculumBreadcrumbDetails(selectedFile?.name)}>
            <CreateButton
                action={() => downloadReport()}
                permissionKey={`${moduleInfo.permissionKeyPrefix}_INDEX`}
                name={"Download"}
            />
        </ToolBar>
        <Space direction="vertical"
            style={{ width: '100%', marginTop: '2rem' }}
            size="large"
            wrap
        >
            {selectedFile && selectedFile?.viewFile != undefined && <PDFComponent url={selectedFile.viewFile} />}
        </Space>
    </>
}
export default DetailsComponent;
